import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { useTheme } from '@mui/material';
import { DepthIcon, OrganizationIcon } from '@icons/index';
import { withLogin } from '@hoc/withLogin';
import { Lnb } from '../../common/lnb';
import * as S from './UserGroupStyles';

export const UserGroup = withLogin(() => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <S.Container>
      <Lnb
        menuItem={[
          {
            name: t('User_Group.Settings'),
            icon: <OrganizationIcon width={20} height={20} color={theme.colors['ic-gray-main']} />,
            subMenu: [
              {
                name: t('User_Group.Company_Info_Management'),
                icon: <DepthIcon width={16} height={16} color={theme.colors['ic-gray-main']} />,
                selectedIcon: <DepthIcon width={16} height={16} color={theme.colors['ic-primary-light']} />,
                to: 'companyInfo',
              },
              {
                name: `${t('Member_LNB_04')}`,
                icon: <DepthIcon width={16} height={16} color={theme.colors['ic-gray-main']} />,
                selectedIcon: <DepthIcon width={16} height={16} color={theme.colors['ic-primary-light']} />,
                to: 'groupMgmt',
              },
              {
                name: `${t('Member_LNB_05')}`,
                icon: <DepthIcon width={16} height={16} color={theme.colors['ic-gray-main']} />,
                selectedIcon: <DepthIcon width={16} height={16} color={theme.colors['ic-primary-light']} />,
                to: 'memberMgmt',
              },
              {
                name: `${t('Member_LNB_06')}`,
                icon: <DepthIcon width={16} height={16} color={theme.colors['ic-gray-main']} />,
                selectedIcon: <DepthIcon width={16} height={16} color={theme.colors['ic-primary-light']} />,
                to: 'managerMgmt',
              },
              {
                name: `${t('Security.lnb')}`,
                icon: <DepthIcon width={16} height={16} color={theme.colors['ic-gray-main']} />,
                selectedIcon: <DepthIcon width={16} height={16} color={theme.colors['ic-primary-light']} />,
                to: 'security',
              },
              {
                name: `${t('ScimToken.lnb')}`,
                icon: <DepthIcon width={16} height={16} color={theme.colors['ic-gray-main']} />,
                selectedIcon: <DepthIcon width={16} height={16} color={theme.colors['ic-primary-light']} />,
                to: 'scim-tokens',
              },
              {
                name: `${t('SsoProvider.lnb')}`,
                icon: <DepthIcon width={16} height={16} color={theme.colors['ic-gray-main']} />,
                selectedIcon: <DepthIcon width={16} height={16} color={theme.colors['ic-primary-light']} />,
                to: 'sso-providers',
              },
            ],
          },
        ]}
      />
      <Outlet />
    </S.Container>
  );
});
